// @import

import { ensureHTMLNodeList } from "@src/js/lib/ensure";
import Alpine from "alpinejs";

Alpine.directive("push-encadrants", (element, {}, { cleanup }) => {
  const dom = {
    cards: ensureHTMLNodeList(element.querySelectorAll(".c-push-encadrants__item")),
    moreBtn: element.querySelector(".c-push-encadrants__load-more"),
  };

  if (!dom.moreBtn) return;

  const totalCards = dom.cards.length;
  const perPage = parseInt(element.dataset.perPage || "18", 10);
  const totalPages = Math.ceil(totalCards / perPage);
  let currentPage = 1;

  function showMoreCards() {
    if (currentPage < totalPages) {
      currentPage++;
      const start = (currentPage - 1) * perPage;
      const end = currentPage * perPage;
      dom.cards.forEach((card, index) => {
        if (index >= start && index < end) {
          card.classList.remove("c-push-encadrants__item--hidden");
        }
      });
    }
    const allCardsDisplayed = Array.from(dom.cards).every(
      (card) => !card.classList.contains("c-push-encadrants__item--hidden"),
    );
    if (allCardsDisplayed) {
      dom.moreBtn?.remove();
    }
  }

  dom.moreBtn?.addEventListener("click", showMoreCards);

  cleanup(() => {
    dom.moreBtn?.removeEventListener("click", showMoreCards);
  });
});
